export const moveSelection = (dx, dy) => ({
    type: 'MOVE_SELECTION_BY',
    dx,
    dy,
});

export const resizeSelection = (bounds, targetBounds, handle, aspectLock) => ({
    type: 'RESIZE_SELECTION_BY',
    bounds,
    targetBounds,
    handle,
    aspectLock
});

export const setSelection = (selection) => {
    // console.log('setselection', selection)
    return {
        type: 'SET_SELECTION',
        selection,
    }
}
export const setActive = (active) => {
    // console.log('setActive', selection)
    return {
        type: 'SET_ACTIVE',
        active,
    }
}

export const addSelection = (selection) => ({
    type: 'ADD_SELECTION',
    selection,
})
export const removeSelection = (selection) => ({
    type: 'REMOVE_SELECTION',
    selection,
})
export const resetSelection = (selection) => ({
    type: 'RESET_SELECTION',
    selection,
})

export default {
    setSelection,    
    setActive,
    addSelection,
    removeSelection,
    resetSelection,

    moveSelection,
    resizeSelection
}